import { FlyIn } from '@coop/components';
import classNames from 'classnames';
import { type CSSProperties, type PropsWithChildren, type ReactNode } from 'react';

import styles from './FlyInHeader.module.scss';

const Root = (
    props: PropsWithChildren<{
        heading: string;
        navigationSlot?: ReactNode;
        style?: CSSProperties;
        className?: string;
        hideSubheaderBorder?: boolean;
    }>,
) => {
    return (
        <FlyIn.Header
            heading={props.heading}
            hideSubheaderBorder={props.hideSubheaderBorder}
            navigationSlot={props.navigationSlot}
            style={props.style}
            className={props.className}
        >
            {props.children}
        </FlyIn.Header>
    );
};

const Text = (props: PropsWithChildren<{ className?: string }>) => {
    return <p className={classNames(styles.Text, props.className)}>{props.children}</p>;
};

const Link = ({
    boxed,
    ...props
}: PropsWithChildren<React.ButtonHTMLAttributes<HTMLButtonElement>> & {
    boxed?: boolean;
}) => {
    return (
        <button
            type="button"
            className={classNames(props.className, styles.Link, boxed && styles.LinkBoxed)}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...props}
        >
            {props.children}
        </button>
    );
};

const FlyInHeader = {
    Root,
    Text,
    Link,
};

export default FlyInHeader;
